import {
  GET_INVOICE_EXTRACT,
  INVOICE_EXTRACT_DATA,
  INVOICE_EXTRACT_ERROR,
} from 'store/constants'

export const getInvoiceExtract = (contract) => ({
  type: GET_INVOICE_EXTRACT,
  payload: { contract },
})

export const invoiceExtractData = (data) => ({
  type: INVOICE_EXTRACT_DATA,
  payload: data,
})

export const invoiceExtractError = (error) => ({
  type: INVOICE_EXTRACT_ERROR,
  payload: error,
})
